(function () {
  function getNextUrl(scopeEl) {
    if (!scopeEl) return null;
    var nextLink = scopeEl.querySelector('a[aria-label*="next" i]');
    return nextLink ? nextLink.href : null;
  }

  function initInfiniteScroll(container) {
    if (!container || container.dataset.infiniteInit) return;

    var grid = container.querySelector('#product-grid');
    var paginationWrapper = container.querySelector('.pagination-wrapper');
    if (!grid || !paginationWrapper) return;

    var nextUrl = getNextUrl(paginationWrapper);
    if (!nextUrl) return; // nothing to load — leave native pagination visible

    container.dataset.infiniteInit = 'true';
    paginationWrapper.style.display = 'none';

    // Sentinel placed right after the grid so its position tracks the last row.
    var sentinel = document.createElement('div');
    sentinel.className = 'della-infinite-sentinel';
    sentinel.style.cssText = 'display:block;width:100%;height:1px;';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    var loading = false;
    var THRESHOLD = 800; // px before the sentinel enters view

    function inRange() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return sentinel.getBoundingClientRect().top <= vh + THRESHOLD;
    }

    function maybeLoad() {
      if (!loading && nextUrl && inRange()) loadNext();
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#product-grid');
          if (newGrid) {
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(newGrid.children).forEach(function (c) { frag.appendChild(c); });
            grid.appendChild(frag);
          }
          nextUrl = getNextUrl(doc.querySelector('.pagination-wrapper'));
          loading = false;
          if (!nextUrl) cleanup();
          else maybeLoad(); // chain-load if the new content is still short
        })
        .catch(function () { loading = false; });
    }

    // Primary trigger: IntersectionObserver. Fallback: throttled scroll/resize
    // (robust to fast / momentum / smooth-scroll cases where IO can be skipped).
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) maybeLoad();
      }, { rootMargin: THRESHOLD + 'px 0px ' + THRESHOLD + 'px 0px' });
      io.observe(sentinel);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; maybeLoad(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    function cleanup() {
      if (io) io.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (sentinel && sentinel.parentNode) sentinel.remove();
    }

    // Initial check in case the first page already sits within range.
    maybeLoad();
  }

  function init() {
    document.querySelectorAll('#ProductGridContainer').forEach(initInfiniteScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
